import { render, staticRenderFns } from "./AddToHomeScreenHandler.vue?vue&type=template&id=1404ebf2&scoped=true&lang=pug&"
import script from "./AddToHomeScreenHandler.vue?vue&type=script&lang=ts&"
export * from "./AddToHomeScreenHandler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1404ebf2",
  null
  
)

export default component.exports